import { EditDialog } from '@104ha/base-ui';
import { useCallback, useEffect, useRef, useState } from 'react';

interface IOptions {
	theme?: 'new' | 'edit';
}

const useDialog = <T extends any = any>(DlgComps: any = EditDialog, options?: IOptions) => {
	const [showEditDialog, setShowEditDialog] = useState<any>(null);
	const editDlgRef = useRef<typeof DlgComps>(null);

	const openDialog = useCallback(
		(data?: T) => {
			setShowEditDialog(data || true);
		},
		[setShowEditDialog]
	);

	useEffect(() => {
		if (showEditDialog) {
			if (typeof showEditDialog === 'object') {
				editDlgRef.current?.setValues(showEditDialog);
			}
		}
	}, [showEditDialog]);

	const _Dialog = ({ onSuccess, data, ...otherProps }: { onSuccess?: () => any; data?: { [key: string]: any } }) => {
		const id = showEditDialog?.id;
		const dataSet: any[] = [
			{
				id,
				data,
			},
		];

		return (
			showEditDialog && (
				<DlgComps
					id={showEditDialog.id}
					ref={editDlgRef}
					close={() => setShowEditDialog(null)}
					onSuccess={onSuccess}
					rowData={showEditDialog}
					dataSet={dataSet}
					editable={false}
					navigator={false}
					{...otherProps}
				/>
			)
		);
	};

	return [_Dialog, openDialog, editDlgRef] as const;
};

export { useDialog };
